import { useContext } from 'react';
import { ChatMessagesContext } from './chatMessagesContext';

export function useChatMessages() {
  const context = useContext(ChatMessagesContext);

  if (context === null) {
    throw new Error('useChatMessages must be used within ChatMessagesProvider');
  }

  return context;
}
